import { Button } from '@opendoor/mosaic';
import { download, generateCsv, mkConfig } from 'export-to-csv';

import { useSessionContext } from '../../../contexts/SessionContext';
import { OdProtosIndextriousData_Filter_Operator } from '../../../graphql/athena/types/globalTypes';
import useSearchWorkOrders from '../../../graphql/queries/indextrious/SearchWorkOrderIndex';
import { notEmpty } from '../../../utils/types';
import { FIELDS } from '../constants';

const config = mkConfig({ useKeysAsHeaders: true });

const downloadAsCsv = (data: any) => {
  const csv = generateCsv(config)(data);
  download(config)(csv);
};

const ExportToCSV = () => {
  const { session } = useSessionContext();
  const branchesIds: string[] = (session.human?.vendorBranches.filter(notEmpty) || []).map(
    (b) => b.id,
  );

  const isAdmin = session.human?.opendoor_internal_access || false;

  const authFilter = isAdmin
    ? []
    : [
        {
          value: {
            single: {
              field: FIELDS.ASSIGNED_TO_BRANCH_ID,
              operator: OdProtosIndextriousData_Filter_Operator.IN,
              operand: {
                value: {
                  arrayValue: {
                    value: branchesIds,
                  },
                },
              },
            },
          },
        },
      ];

  const { data, loading } = useSearchWorkOrders({
    variables: {
      filters: [
        ...authFilter,
        {
          value: {
            exists: {
              value: {
                field: FIELDS.IN_ALL_TAB,
              },
            },
          },
        },
        {
          value: {
            single: {
              field: FIELDS.STATE,
              operator: OdProtosIndextriousData_Filter_Operator.IN,
              operand: {
                value: {
                  arrayValue: {
                    value: [
                      'FINALIZED',
                      'SCOPE_ACCEPTED',
                      'WORK_COMPLETED',
                      'WORK_VALIDATED',
                      'REWORK_REQUESTED',
                      'WORK_COMMENCED',
                    ],
                  },
                },
              },
            },
          },
        },
      ],
      sortBy: [
        {
          field: 'date_requested_at',
          desc: true,
        },
      ],
      page: {
        size: 500,
        number: 0,
      },
    },
  });

  if (loading) {
    return (
      <Button color="primary" variant="outlined" disabled>
        Loading...
      </Button>
    );
  }

  const handleExport = () => {
    const dataToExport = data?.results?.map((result: any) => {
      return {
        id: result.id,
        no_of_line_items: result.lineItemIds.length,
        status: result.progress,
        full_address: result.address.fullAddress,
        postal_code: result.address.postalCode,
        market: result.market,
        kind: result.kind,
        date_requested_at: result.dateRequestedAt,
        scheduled_start_at: result.scheduledStartAt,
        scheduled_stop_at: result.scheduledStopAt,
        total_cost_in_cents: result.acceptedCostCents,
        manager_name: result.managerContact?.fullName,
        manager_phone: result.managerContact?.primaryPhone,
        manager_email: result.managerContact?.email,
      };
    });

    downloadAsCsv(dataToExport);
  };

  return (
    <Button color="primary" onClick={handleExport} variant="outlined">
      Export CSV
    </Button>
  );
};

export default ExportToCSV;
